import { render, staticRenderFns } from "./suggestion_diff_header.vue?vue&type=template&id=5a834525"
import script from "./suggestion_diff_header.vue?vue&type=script&lang=js"
export * from "./suggestion_diff_header.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports